export default [{  // 资产领用列表
	path: 'receive',
	name: 'm_app_asset_receive',
	meta: {
		title: '资产领用',
		keepAlive: true
	},
	component: () => import('@/pages/staff/assets/receive_list')
}, {  // 资产领用详情
	path: 'receive/detail',
	meta: {
		title: '资产领用详情'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/assets/receive_detail')
}, {  // 资产领用编辑
	path: 'receive/edit',
	meta: {
		title: '发起资产领用'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/assets/receive_edit')
}, {  // 资产归还列表
	path: 'return',
	name: 'm_app_asset_return',
	meta: {
		title: '资产归还',
		keepAlive: true
	},
	component: () => import('@/pages/staff/assets/return_list')
}, {  // 资产归还详情
	path: 'return/detail',
	meta: {
		title: '资产归还详情'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/assets/return_detail')
}, {  // 资产归还编辑
	path: 'return/edit',
	meta: {
		title: '发起资产归还'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/assets/return_edit')
}, {  // 资产维修列表
	path: 'repair',
	name: 'm_app_asset_repair',
	meta: {
		title: '资产维修',
		keepAlive: true
	},
	component: () => import('@/pages/staff/assets/repair_list')
}, {  // 资产维修详情
	path: 'repair/detail',
	meta: {
		title: '维修记录详情'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/assets/repair_detail')
}, {  // 资产维修编辑
	path: 'repair/edit',
	meta: {
		title: '新增维修记录'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/assets/repair_edit')
}];